import React from 'react';
import './Certificate.css';

const Certificate = () => {
  return (
    <div>
    <div className="heading"> CERTIFICATES </div>
      <div className="all_images">
        <div className="certificates"> <img src="/images/c1.jpg" alt="" /> </div>
        <div className="certificates"> <img src="/images/c2.jpg" alt="" /> </div>
        <div className="certificates"> <img src="/images/c3.jpg" alt="" /> </div>
        <div className="certificates"> <img src="/images/c4.jpg" alt="" /> </div>
      </div>
    </div>
  )
}

export default Certificate
